<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <Spin fix v-if="dataGetting"></Spin>
      <Alert show-icon type="error" v-else-if="dataGetError">获取数据失败</Alert>
      <div class="req-form" v-else>
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="实例名称" prop="name">
            <Input v-model="reqForm.name" :maxlength="255" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { changePrivateCloudServer, detailPrivateCloudServer } from '@/api/private-cloud/server'
export default {
  name: 'server-edit',
  data () {
    return {
      title: '编辑实例',
      flavorList: [],
      serverData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        id: '',
        name: ''
      },
      reqRule: {
        name: [
          { required: true, message: '实例名称不能为空', trigger: 'blur' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false,
      dataGetting: false,
      dataGetError: false
    }
  },
  methods: {
    openModal (id) {
      this.dataGetting = true
      this.dataGetError = false
      this.modalShow = true
      detailPrivateCloudServer(id).then(res => {
        this.reqForm.id = res.data.server.id
        this.reqForm.name = res.data.server.name
        this.dataGetting = false
      }).catch(res => {
        this.dataGetError = true
        this.dataGetting = false
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          this.submitting = true
          changePrivateCloudServer(this.reqForm, this.reqForm.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
